// HEADER: TITLES
export const TITLE_FORM_POINT = 'Datos de Puntos de Lavanderia'
export const TITLE_FORM_EQUIPMENT = 'Datos de Equipos de Lavanderia'
export const TITLE_FORM_SUPPLIER = 'Datos de Proveedores'
export const TITLE_FORM_LEGAL_REPRESENTATIVE = 'Datos del Representante Legal'
export const TITLE_FORM_SERVICE = 'Datos del Servicio'
export const TITLE_FORM_LAUNDRY_GUEST = 'Datos de la Orden de Lavado Huésped'
export const TITLE_FORM_LAUNDRY_CLOTHE = 'Datos de la Orden de Lavado Ropa y otros'
export const TITLE_FORM_INSPECT = 'Datos de la inspección'
export const TITLE_FORM_CONFIG_HOURS = 'Datos de Configuración de Horas'
export const TITLE_FORM_CONFIG_DAYS = 'Datos de Configuración de Días'
export const TITLE_FORM_MANAGEMENT_SEQUENTIAL = 'Datos de Gestión Secuencial'


